const Index = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "500px",
        width: "100%",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h1>404</h1>
        <p>Not found</p>
      </div>
    </div>
  );
};

export default Index;
